export default __webpack_public_path__ + "static/media/art-pro-brw-4.84fa6d8d.png";